import { PlenaryStudioVersionHistoryPage } from '@hendrx/core/plenary/pages/PlenaryStudioVersionHistoryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/plenary/edit/$plenaryDraftId/versions/')({
  component: RouteComponent
});

function RouteComponent() {
  const { plenaryDraftId } = Route.useParams();
  return <PlenaryStudioVersionHistoryPage plenaryDraftId={plenaryDraftId} />;
}
